<h4 class="modal-header">{{ permissions.canEditProfile ? 'Update' : 'View' }} User Details</h4>
<div class="modal-body" *ngIf="form">
    <cm-profile-card-avatar
        class="mr-2"
        [profile]="_profile"
        [canUpdateAvatar]="false"
        [userId]="currentProfile.user_id"
        [manualUpdate]="true"
        (updateAvatar)="updateAvatar($event)"
    ></cm-profile-card-avatar>
    <form [formGroup]="form" autocomplete="off" class="form">
        <div class="form-line" *ngIf="roleId === ROLE_CODES.PROFESSIONAL">
            <div class="professional-role">
                <label class="user-details__label professional-option-label user-details__label-professional">
                    Professional Type:
                    <i
                        class="fa fa-question-circle"
                        container="body"
                        ngbTooltip="A “professional” is either an individual or a physical entity
               (“facility”) that possesses a certificate/credential and for whom you wish to track the
               progress of their certification/credentialing. Please select the appropriate type of
               certificate/credential holder."
                    ></i>
                </label>
                <cm-radio-group
                    class="professional-type"
                    formControlName="profile_type_id"
                    [options]="profileTypeIdOptions"
                    (ngModelChange)="profileTypeIdChange($event)"
                >
                </cm-radio-group>
            </div>
        </div>
        <div class="form-line">
            <div class="form-group"
                 [ngClass]="{ 'form-group-max-width':
                    !permissions.legalNameFeatureFlag && form.get('profile_type_id').value === PROFILE_TYPE_ID.FACILITY
                 }">
                <label class="form-label form-label--bold required">
                    {{ form.get('profile_type_id').value === PROFILE_TYPE_ID.INDIVIDUAL ? 'First Name' : 'Name' }}
                </label>
                <cm-text-input
                    class="inner-component"
                    formControlName="first_name"
                    [class.error]="form.get('first_name').errors && showErrors"
                ></cm-text-input>
            </div>
            <div class="form-group" *ngIf="form.get('profile_type_id').value === PROFILE_TYPE_ID.INDIVIDUAL">
                <label class="form-label form-label--bold required">Last Name</label>
                <cm-text-input
                    class="inner-component"
                    formControlName="last_name"
                    [class.error]="form.get('last_name').errors && showErrors"
                ></cm-text-input>
            </div>
            <div class="form-group" *ngIf="permissions.legalNameFeatureFlag &&
                form.get('profile_type_id').value === PROFILE_TYPE_ID.FACILITY">
                <div class="label-wrapper">
                    <label class="form-label form-label--bold required">Legal Name</label>
                    <i
                        class="fa fa-question-circle question-circle-single"
                        container="body"
                        tooltipClass="max-400"
                        placement="bottom"
                        [ngbTooltip]="HELP_MESSAGES.LEGAL_NAME_FACILITY"
                    ></i>
                </div>
                <cm-text-input
                    class="inner-component"
                    formControlName="legalFirstName"
                    [class.error]="form.get('legalFirstName').errors && showErrors"
                    placeholder="Legal Name"
                ></cm-text-input>
            </div>
            <div class="form-group">
                <label class="form-label form-label--bold required">Email</label>
                <cm-text-input
                    class="inner-component"
                    formControlName="email"
                    [cmDisableControl]="
                        !permissions.canEditProfile || currentProfile.profile_id === _profile.profile_id
                    "
                    [class.error]="form.get('email').errors && showErrors"
                ></cm-text-input>
            </div>
        </div>
        <ng-container *ngIf="permissions.legalNameFeatureFlag && roleId === ROLE_CODES.PROFESSIONAL
            && form.get('profile_type_id').value === PROFILE_TYPE_ID.INDIVIDUAL">
            <div class="legal-wrapper">
                <label class="form-label form-label--bold">
                    Legal Name:
                </label>
                <i
                    class="fa fa-question-circle question-circle-group"
                    container="body"
                    tooltipClass="max-400"
                    placement="bottom-right"
                    [ngbTooltip]="HELP_MESSAGES.LEGAL_NAME_INDIVIDUAL"
                ></i>
            </div>
            <div class="form-line">
                <div class="form-group">
                    <cm-text-input
                        class="inner-component"
                        formControlName="legalFirstName"
                        [class.error]="form.get('legalFirstName').errors && showErrors"
                        placeholder="Legal First Name"
                        (ngModelChange)="onLegalNameChange($event, 'legalLastName')"
                    ></cm-text-input>
                </div>
                <div class="form-group">
                    <cm-text-input
                        class="inner-component"
                        formControlName="legalMiddleName"
                        [class.error]="form.get('legalMiddleName').errors && showErrors"
                        placeholder="Legal Middle Name"
                    ></cm-text-input>
                </div>
                <div class="form-group">
                    <cm-text-input
                        class="inner-component"
                        formControlName="legalLastName"
                        [class.error]="form.get('legalLastName').errors && showErrors"
                        placeholder="Legal Last Name"
                        (ngModelChange)="onLegalNameChange($event, 'legalFirstName')"
                    ></cm-text-input>
                </div>
            </div>
        </ng-container>
        <div class="form-line mobile-phone-number-group">
            <div class="form-group">
                <label class="form-label form-label--bold"> Mobile Phone Country Code </label>
                <cm-select
                    class="inner-component"
                    [options]="phoneCodeCountries"
                    formControlName="mobileCountryId"
                    [class.error]="form.get('mobileCountryId').errors && showErrors"
                >
                </cm-select>
            </div>
            <div class="form-group">
                <label class="form-label form-label--bold">Mobile Phone Number</label>
                <cm-number-input
                    class="inner-component"
                    formControlName="mobilePhoneNumber"
                    [maskConfig]="PHONE_MASK_CONFIG"
                    [class.error]="form.get('mobilePhoneNumber').errors && showErrors"
                ></cm-number-input>
            </div>
        </div>
        <ng-container *ngIf="roleId === ROLE_CODES.ORGANIZATION_ADMIN">
            <div class="form-line" *ngIf="permissions.titlesFeatureFlag">
                <div class="form-group form-group-full-size">
                    <label class="form-label form-label--bold required">Title</label>
                    <cm-select
                        class="inner-component"
                        [options]="titles"
                        formControlName="title_id"
                        [class.error]="form.get('title_id').errors && showErrors"
                    >
                    </cm-select>
                </div>
            </div>
            <div class="form-line" *ngIf="permissions.locationsFeatureFlag">
                <div class="form-group">
                    <label class="form-label form-label--bold required">Countries</label>
                    <cm-multi-select
                        placeholder="Countries"
                        class="inner-component"
                        [class.error]="form.get('country_ids').errors && showErrors"
                        [options]="countries"
                        [params]="multiSelectParams"
                        (ngModelChange)="onCountryChange($event)"
                        formControlName="country_ids"
                    >
                    </cm-multi-select>
                </div>
                <div class="form-group">
                    <label class="form-label form-label--bold required"
                        >{{ organizationLabels[OrganizationsLabelType.LOCATION_REGION] }}(s)</label
                    >
                    <cm-multi-select
                        placeholder="{{ organizationLabels[OrganizationsLabelType.LOCATION_REGION] }}(s)"
                        class="inner-component"
                        [class.error]="form.get('region_ids').errors && showErrors"
                        [options]="regions"
                        [params]="multiSelectParams"
                        (ngModelChange)="onRegionChange($event)"
                        formControlName="region_ids"
                        [cmDisableControl]="!permissions.canEditProfile || !form.get('country_ids').value?.length"
                    >
                    </cm-multi-select>
                </div>
                <div class="form-group">
                    <label class="form-label form-label--bold required"
                        >{{ organizationLabels[OrganizationsLabelType.LOCATION_OFFICE] }}(s)</label
                    >
                    <cm-multi-select
                        placeholder="{{ organizationLabels[OrganizationsLabelType.LOCATION_OFFICE] }}(s)"
                        class="inner-component"
                        [class.error]="form.get('office_ids').errors && showErrors"
                        [options]="offices"
                        [params]="multiSelectParams"
                        formControlName="office_ids"
                        [cmDisableControl]="!permissions.canEditProfile || !form.get('region_ids').value?.length"
                    >
                    </cm-multi-select>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="roleId === ROLE_CODES.PROFESSIONAL">
            <ng-container *ngIf="permissions.locationsFeatureFlag">
                <div class="form-line">
                    <div class="form-group">
                        <label class="form-label form-label--bold required">Primary Country</label>
                        <cm-select
                            class="inner-component"
                            [options]="countries"
                            formControlName="country_id"
                            [class.error]="form.get('country_id').errors && showErrors"
                            (ngModelChange)="onCountryChange([$event])"
                        >
                        </cm-select>
                    </div>
                    <div class="form-group">
                        <label class="form-label form-label--bold required"
                            >Primary {{ organizationLabels[OrganizationsLabelType.LOCATION_REGION] }}</label
                        >
                        <cm-select
                            class="inner-component"
                            [cmDisableControl]="!permissions.canEditProfile || !form.get('country_id').value"
                            [options]="regions"
                            formControlName="region_id"
                            [class.error]="form.get('region_id').errors && showErrors"
                            (ngModelChange)="onRegionChange([$event])"
                        >
                        </cm-select>
                    </div>
                    <div class="form-group">
                        <label class="form-label form-label--bold required"
                            >Primary {{ organizationLabels[OrganizationsLabelType.LOCATION_OFFICE] }}</label
                        >
                        <cm-select
                            class="inner-component"
                            [cmDisableControl]="!permissions.canEditProfile || !form.get('region_id').value"
                            [options]="offices"
                            formControlName="office_id"
                            [class.error]="form.get('office_id').errors && showErrors"
                            (ngModelChange)="onOfficeChange()"
                        >
                        </cm-select>
                    </div>
                </div>
                <div>
                    <div class="form-line" *ngIf="expand">
                        <div class="form-group">
                            <label class="form-label form-label--bold add-label">Additional Countr(ies)</label>
                            <cm-multi-select
                                placeholder="Countries"
                                class="inner-component"
                                [class.error]="form.get('country_ids').errors && showErrors"
                                [options]="countries"
                                [params]="multiSelectParams"
                                (ngModelChange)="onCountryChange($event, true)"
                                formControlName="country_ids"
                            >
                            </cm-multi-select>
                        </div>
                        <div class="form-group">
                            <label class="form-label form-label--bold add-label"
                                >Additional {{ organizationLabels[OrganizationsLabelType.LOCATION_REGION] }}(s)</label
                            >
                            <cm-multi-select
                                placeholder="{{ organizationLabels[OrganizationsLabelType.LOCATION_REGION] }}(s)"
                                class="inner-component"
                                [class.error]="form.get('region_ids').errors && showErrors"
                                [options]="additionalRegions"
                                [params]="multiSelectParams"
                                (ngModelChange)="onRegionChange($event, true)"
                                formControlName="region_ids"
                                [cmDisableControl]="
                                    !permissions.canEditProfile || !form.get('country_ids').value?.length
                                "
                            >
                            </cm-multi-select>
                        </div>
                        <div class="form-group">
                            <label class="form-label form-label--bold add-label"
                                >Additional {{ organizationLabels[OrganizationsLabelType.LOCATION_OFFICE] }}(s)</label
                            >
                            <cm-multi-select
                                placeholder="{{ organizationLabels[OrganizationsLabelType.LOCATION_OFFICE] }}(s)"
                                class="inner-component"
                                [class.error]="form.get('office_ids').errors && showErrors"
                                [options]="additionalOffices"
                                [params]="multiSelectParams"
                                formControlName="office_ids"
                                [cmDisableControl]="
                                    !permissions.canEditProfile || !form.get('region_ids').value?.length
                                "
                            >
                            </cm-multi-select>
                        </div>
                    </div>
                    <p (click)="expand = !expand" class="cm-link" *ngIf="!expand">
                        <span>Add additional location(s)</span>
                    </p>
                </div>
            </ng-container>
            <div class="form-line" *ngIf="permissions.organizationRolesFeatureFlag" id="organization-role-container">
                <div class="form-group form-group-full-size">
                    <label class="form-label form-label--bold required">Role</label>
                    <ng-container *ngIf="organizationRoles?.length; else noOrganizationRoleTmpl">
                        <cm-select
                            class="inner-component"
                            [options]="organizationRoles"
                            formControlName="organizationRoleId"
                            [class.error]="form.get('organizationRoleId').errors && showErrors"
                        >
                        </cm-select>
                    </ng-container>
                    <ng-template #noOrganizationRoleTmpl>
                        <div>
                            {{ NO_ORGANIZATION_ROLES_MESSAGE }}
                            <a
                                href="javascript:void(0);"
                                class="cm-link role-route-link"
                                (click)="navigateToOrganizationRolesRoute($event)"
                                >here</a
                            >.
                        </div>
                    </ng-template>
                </div>
            </div>
        </ng-container>
        <div [ngClass]="showErrors ? 'mb-3' : 'mb-5'" *ngIf="permissions.managersFeatureFlag">
            <div class="form-line">
                <div class="form-group form-group-full-size">
                    <label class="form-label form-label--bold">Manager</label>
                    <cm-edit-profile-manager
                        [form]="form"
                        [profile]="_profile"
                        [showError]="showErrors"
                        [locationsFeatureFlag]="permissions.locationsFeatureFlag"
                        [isGlobalProfile]="isGlobalProfile"
                        (setManager)="setManager($event)"
                    >
                    </cm-edit-profile-manager>
                </div>
            </div>
            <button *ngIf="managerPlaceholder" class="cm-link" (click)="removeManager()">Remove Manager</button>
        </div>
        <cm-inline-error class="error-block" [errorMessages]="validationMessages" *ngIf="showErrors"></cm-inline-error>
    </form>
</div>
<div class="modal-footer">
    <button class="btn btn-default" (click)="onModalClose()">Close</button>
    <button
        class="btn btn-primary"
        *ngIf="permissions.canEditProfile"
        (click)="onModalConfirm()"
        [disabled]="!form.dirty"
    >
        Update
    </button>
</div>
